import React from "react"

interface ModalReactContext {
	modalBackgroundVisible: boolean
	showModalBackground: () => void
}

export const ModalContext = React.createContext<ModalReactContext | null>(null)

export function useModal(): ModalReactContext {

	const context = React.useContext(ModalContext)
	if (!context) {
		throw new Error(`Modal is undefined in the context.`)
	}

	return context
}
